<template>
  <div class="fps-avatar-wrap">
    <div class="avatar-wrap">
      <img
        class="img"
        :src="avatarSrc"
        :style="{ opacity: loaded ? 1 : 0 }"
        @load="loaded = true"
      />
    </div>
    <img
      v-if="frameGuard"
      class="avatar-frame"
      :style="{ transform: `scale(${frameGuard.scale})` }"
      :src="frameGuard.url"
    />
    <img v-else-if="dressupSrc" class="avatar-frame" :src="dressupSrc" />
    <img v-else-if="frameLevel" class="avatar-frame" :src="frameLevel" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loaded: false,
      isgif: false
    };
  },
  props: {
    src: {
      // 头像url
      type: String,
      default: ''
    },
    dressup: {
      // 装扮url
      type: String,
      default: ''
    },
    crop: {
      // 裁剪参数，默认300x300
      type: [Number, String],
      default: 100
    },
    guardType: {
      // 守护者头像
      type: Number,
      default: 0
    },
    level: {
      // 用户等级
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['avatarBorder', 'avatarLevel']),
    avatarSrc() {
      const { src, crop } = this;
      if (!src) return '';
      return /\?d=|base64/.test(src) ? src : `${src}?d=${crop}x${crop}`;
    },
    dressupSrc() {
      const { dressup, crop } = this;
      if (!dressup) return '';
      return /\?d=|base64/.test(dressup)
        ? dressup
        : `${dressup}?d=${crop}x${crop}`;
    },
    frameGuard() {
      const { guardType, avatarBorder } = this;
      if (!guardType || !avatarBorder) return false;
      const rel = {
        1: {
          // 旧最强守护头像框
          scale: avatarBorder.guardRate,
          url: avatarBorder.guardImage
        },
        2: {
          // 羁绊头像框
          scale: avatarBorder.jiRate,
          url: avatarBorder.jiImage
        },
        3: {
          // 相互守护头像框
          scale: avatarBorder.guardOneRate,
          url: avatarBorder.guardOneImage
        },
        4: {
          // 新版一级守护头像框
          scale: avatarBorder.guardRateLevel1,
          url: avatarBorder.guardImageLevel1
        },
        5: {
          // 新版二级守护头像框
          scale: avatarBorder.guardRateLevel2,
          url: avatarBorder.guardImageLevel2
        },
        6: {
          // 新版三级守护头像框
          scale: avatarBorder.guardRateLevel3,
          url: avatarBorder.guardImageLevel3
        }
      };
      return rel[guardType] || false;
    },
    frameLevel() {
      const { level, avatarLevel } = this;
      if (!level || level < 6 || !avatarLevel) return false;
      return level > 10
        ? avatarLevel.levelHighImage
        : avatarLevel.levelMidImage;
    }
  }
};
</script>

<style lang="scss" scoped>
.fps-avatar-wrap {
  position: relative;
  width: 100%;
  height: auto;
}
// 头像部分
.avatar-wrap {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 0;
  padding-top: 100%;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.2s;
    border-radius: 100%;
    object-fit: cover;
  }
}
// 头像框-守护者
.avatar-frame {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(1.43);
  transform-origin: center center;
}
</style>
